// extracted by mini-css-extract-plugin
export default {"Navbar":"navbar_Navbar__nsAQv","LoginButton":"navbar_LoginButton__YZ+1H"};